<template>
  <div
    class="toast-layout"
    :style="{background:false?'none':'rgba(0, 0, 0, 0.3)'}"
    :class="{'toast-active':visible}"
  >
    <div class="toast-con recharge-con" :style="{minWidth:'868px'}">
      <div class="t-header">
        <span>开具发票</span>
        <i class="iconfont icon-cuowu" @click="handleClick"></i>
      </div>
      <div class="invoice-con">
        <div class="input-con open-edu">
          <input @input="limitMoney" type="text" v-model="edu" placeholder="请输入开票金额">
          <span>可开票额度：{{edititem.max}}元</span>
        </div>
        <div class="invoice edit-invoice">
          <div class="select-con">
            <div :class="{'tag-active':cInvoice==='normal'}" @click="cInvoice='normal'">
              <span>增值税普通发票</span>
              <img :src="`${$cdn}images/tag-icon.png`"  alt />
            </div>
            <div :class="{'tag-active':cInvoice==='zengzhi'}" @click="cInvoice='zengzhi'">
              <span>增值税专用发票</span>
              <i></i>
              <img :src="`${$cdn}images/tag-icon.png`" alt />
            </div>
          </div>
          <div v-if="cInvoice==='normal'">
            <div class="input-con">
              <input type="text" maxlength='20' placeholder="请输入发票抬头" v-model="normal.title" />
              <input type="text" placeholder="请输入18位税务登记号" oninput="value=value.replace(/[^\w\.\/]/ig,'')" maxlength='18' v-model="normal.code" />
            </div>
             <div class="input-con">
              <input type="text" maxlength='30' placeholder="请输入电子邮箱" v-model="normal.emailAddress" />
            </div>
          </div>
          <div v-else>
            <div class="input-con">
              <input type="text" v-model="zengzhi.title" maxlength='20' placeholder="请输入发票抬头" />
              <input type="text" v-model="zengzhi.code" placeholder="请输入18位税务登记号" oninput="value=value.replace(/[^\w\.\/]/ig,'')" maxlength='18' />
            </div>
            <div class="input-con">
              <input type="text" v-model="zengzhi.organizedAddress" maxlength='100' placeholder="注册地址" />
              <input type="text" oninput="value=value.replace(/[^\d\-]/g,'')" v-model="zengzhi.registerPhone" maxlength='20' placeholder="注册电话" />
            </div>
            <div class="input-con">
              <input type="text" v-model="zengzhi.bankName" maxlength='40' placeholder="开户银行" />
              <input type="text" v-model="zengzhi.bankAccount" maxlength='40' placeholder="银行账户" />
            </div>
          </div>
        </div>
        <div class="address edit-address" v-if="cInvoice!=='normal'">
          <div class="input-con">
            <input type="text" v-model="editAdd.shipName" maxlength='20' :placeholder="'姓名'" />
            <input type="text" v-model="editAdd.shipMobile" maxlength='20' :placeholder="'电话'" />
          </div>
          <div class="input-con">
            <citySelect :areaPath="editAdd.shipAreaPath" @currentVal="getCurrentSelect" />
          </div>
          <div class="input-con address-input">
            <input
              type="text"
              v-model="editAdd.shipAddress"
              maxlength='100'
              :placeholder="'详细地址'"
            />
          </div>
        </div>
          <div class="btn parmary" @click="saveInvoice">提交</div>

      </div>
    </div>
  </div>
</template>

<script>
import citySelect from '@/components/citySelect'
import { reg } from '@/util'
import toastZH from '@/store/language/cn/toast'
import toastEN from '@/store/language/en/toast'

export default {
  props: ['visible', 'edititem'],
  components: {
    citySelect
  },
  data () {
    return {
      edu: '',
      cInvoice: 'normal',
      normal: {},
      zengzhi: {},
      editAdd: {},
      address: {},
      tempSelect: '',
      language: localStorage.getItem('language'),
      token: localStorage.getItem('token'),
      toastCode: localStorage.getItem('language') === 'en' ? toastEN : toastZH
    }
  },
  methods: {
    limitMoney (e) {
      let value = e.target.value
      // this.edu = Math.max(Math.min(Number(value.replace(/[^\d]/g, '')), this.edititem.max), 1)

      this.edu = Math.max(Math.min(Number(value.replace(/[^\d]/g, '')), this.edititem.max), 0) || ''
    },
    inputChange (val) {
    },
    handleClick (item = '') {
      this.edu = ''
      this.normal = {}
      this.zengzhi = {}
      this.editAdd = {}
      this.address = {}
      this.$emit('closePoint', item)
    },
    async saveInvoice () {
      if (!this.edu) {
        return this.$toast.show('warn', '请输入开票金额')
      }
      let isObject = function (obj) {
        return JSON.stringify(obj) === '{}' ? '' : obj
      }
      let params = {}
      let invoiceType = ''
      let check = value => {
        for (let i = 0, len = value.length; i < len; i++) {
          if (!value[i].val) {
            return this.$toast.show('warn', (this.language === 'en' ? value[i].En : value[i].name) + this.toastCode['7'])
          }
        }
        return true
      }

      if (this.cInvoice === 'normal') {
        invoiceType = 2
        let title = isObject(this.normal.title)
        let code = isObject(this.normal.code)
        let emailAddress = isObject(this.normal.emailAddress)

        params = {
          invoiceType,
          title,
          code,
          emailAddress
        }
        let checkStr = [
          {
            name: '发票抬头',
            En: 'Title',
            val: title
          },
          {
            name: '电子邮箱',
            En: 'Email',
            val: emailAddress
          }
        ]
        if (!check(checkStr)) {
          return
        }
        if (code && code.length !== 18) {
          return this.$toast.show('warn', this.toastCode['21'])
        }
        if (!reg.email.test(emailAddress)) {
          return this.$toast.show('warn', this.toastCode['8'])
        }
      } else {
        let {title: title1, code: code1, organizedAddress: organizedAddress1, registerPhone: registerPhone1, bankName: bankName1, bankAccount: bankAccount1} = this.zengzhi

        invoiceType = 3
        let title = isObject(title1)
        let code = isObject(code1)
        let organizedAddress = isObject(organizedAddress1)
        let registerPhone = isObject(registerPhone1)
        let bankName = isObject(bankName1)
        let bankAccount = isObject(bankAccount1)

        params = {
          invoiceType,
          title,
          code,
          organizedAddress,
          registerPhone,
          bankName,
          bankAccount
        }
        let checkStr = [
          {
            name: '发票抬头',
            En: 'Title',
            val: title
          },
          {
            name: '税务登记号',
            En: 'Code',
            val: code
          },
          {
            name: '注册地址',
            En: 'Organized Address',
            val: organizedAddress
          },
          {
            name: '注册电话',
            En: 'Register Phone',
            val: registerPhone
          },
          {
            name: '开户银行',
            En: 'Bank Name',
            val: bankName
          },
          {
            name: '银行账号',
            En: 'Bank Account',
            val: bankAccount
          }
        ]
        if (!check(checkStr)) {
          return
        }
        if (!code && code.length !== 18) {
          return this.$toast.show('warn', this.toastCode['21'])
        }

        if (!reg.guhua.test(registerPhone)) {
          return this.$toast.show('warn', this.toastCode['22'])
        }
      }
      let {shipName = '', shipMobile = '', shipAddress = ''} = this.editAdd

      if (this.cInvoice !== 'normal') {
        this.editAdd.shipAreaPath = this.tempSelect.join(',')
        this.editAdd.shipName = shipName || ''
        this.editAdd.shipMobile = shipMobile || ''
        this.editAdd.shipAddress = shipAddress || ''

        let temp = Object.keys(this.editAdd)
        temp.forEach(item => {
          params[item] = this.editAdd[item] || ''
        })
        let arr = Object.keys(params)
        for (let i = 0; i < arr.length; i++) {
          if (!params[arr[i]]) {
            return this.$toast.show('warn', '请完善收货信息')
          }
        }
      }
      params['cameraId'] = this.edititem.cameraId
      params['amount'] = Number(this.edu)

      let res = await this.$http
        .post('/user/invoice/add', params, {
          headers: {
            token: localStorage.getItem('token')
          }
        })
      let response = res.data

      if (response.code === 0) {
        this.$bus.$emit('refreshInvoice')
        this.$toast.show('success', '开票成功', () => {
          this.handleClick()
        })
      } else {
        return this.$toast.show('warn', '信息填写不能为空', () => {
          this.handleClick()
        })
      }
    },
    getCurrentSelect (data) {
      this.tempSelect = data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/components/toast/editInvoice.vue